import React, { type HTMLAttributes } from 'react';
import Truncate from 'react-truncate';
import classNames from 'classnames';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import { CoreLink, DynamicMediaItem } from '@uncinc/react-drupal-core';
import {
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';

import type { NodeArticle } from '../../../../types/uncinc_profile/nodes';
import { dateFormatter } from '../../../../helpers';

import './style.scss';

interface NodeArticleTeaserProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<NodeArticle>;
  classes: string;
}

const NodeArticleTeaser: React.FC<NodeArticleTeaserProps> = ({ entity, classes }) => {
  const article = entity.toJS();
  const title = article.title[0].value;
  const lang = article.langcode[0]?.value;
  const path = article.paths[lang];
  const media = article.field_media_item[0];
  const articleType = article.field_article_type[0]?.entity.name[0]?.value;

  return (
    <div className={classNames('NodeArticleTeaser', classes)}>
      <div className="NodeArticleTeaser__image">
        {media && (
          <DynamicMediaItem
            media={media}
            imageAspectRatio="1_1"
          />
        )}
      </div>
      <div className="NodeArticleTeaser__info">
        {articleType && (
          <div className="NodeArticleTeaser__tag">
            {articleType}
          </div>
        )}
        <div className="NodeArticleTeaser__date" />
        {dateFormatter(article.created[0]?.value, lang)}
      </div>
      <div className="NodeArticleTeaser__content">
        <h3 className="NodeArticleTeaser__heading">
          <CoreLink href={path}>
            <Truncate lines={2} ellipsis="...">
              {title}
            </Truncate>
          </CoreLink>
        </h3>
        <Truncate lines={3}>
          <WysiwygField
            html={article.body[0]?.summary}
          />
        </Truncate>
      </div>
    </div>
  );
};

export default NodeArticleTeaser;
